import {CLOSE_BET_HISTORY, OPEN_BET_HISTORY, TOGGLE_FILTER_WINS_BET_HISTORY} from '../constants/actionTypes';

export function openBetHistory(response) {
    return {type: OPEN_BET_HISTORY, betHistory: response.RecentBets};
}

export function closeBetHistory() {
    return {type: CLOSE_BET_HISTORY};
}

export function toggleFilterWinsBetHistory() {
    return {type: TOGGLE_FILTER_WINS_BET_HISTORY};
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/actions/betHistoryActions.js